// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import NumberFormatter from '../../i18n/numberformatter';
import theme from '../../styled-components/dark';
import type { OutcomeStatus } from '../../types/history';
import HistoryItemOutcomeMyMatchLine from '../HistoryItemOutcomeMyMatchLine';
import MyMatchDynamicBackground, { MyMatchDynamicBackgroundRadialClassName } from '../MyMatchDynamicBackground';
import RoundedButton from '../RoundedButton';

const BottomDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 1em;
`;

const StyledButton = styled(RoundedButton)`
  height: 2em;
  width: 56%;
`;

const OddDiv = styled.div`
  border-radius: 1.3em;
  border: 1px solid ${theme.TMMOdd.borderColor};
  height: 2em;
  width: 41%;
  padding: 0 1em;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Center = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: baseline;
`;

const Gap = styled.div`
  width: 1em;
`;

const TypoOdd = styled.div`
  color: ${theme.TMMOdd.oddLabelColor};
`;

const TypoNum = styled.div`
  color: ${theme.TMMOdd.oddValueColor};
  font-size: 1.3em;
  margin-left: 0.2em;
`;

const WRAPPER_HEIGHT_PADDING = 0.5;

const Wrapper = styled.div`
  border-radius: 1em;
  padding: ${WRAPPER_HEIGHT_PADDING}em;

  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

const OutcomesWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const StyledMyMatchDynamicBackground = styled(MyMatchDynamicBackground)`
  border-radius: 1em;
  z-index: -1;

  --MyMatchDynamicBackground-defaultBackgroundColor: ${theme.MatchBetGroup.backgroundColor};

  & .${MyMatchDynamicBackgroundRadialClassName} {
    left: 0%;
    top: -9.5em;
    width: 400%;
  }
`;

type MatchTopMyMatchCardProps = {
  items: Array<{
    title: string;
    description: string;
    outcomeStatus: OutcomeStatus;
  }>;
  isSelected?: boolean;
  color?: string;
  selectedColor?: string;
  backgroundColor?: string;
  borderColor?: string;
  selectedBorderColor?: string;
  selectedBackgroundColor: string;
  disabled?: boolean;
  odds?: string;
  label?: string;
  onClick: () => void;
  myMatchViewModeIsAvailable: boolean;
  className?: string;
};

const MatchTopMyMatchCard = ({
  items,
  odds,
  onClick,
  isSelected = true,
  label = __('Select'),
  color = theme.History.historyFilterButton.inactive.color,
  selectedColor = theme.History.historyFilterButton.active.color,
  backgroundColor = theme.History.historyFilterButton.inactive.backgroundColor,
  borderColor = theme.MatchBetFilter.default.borderColor,
  selectedBorderColor = theme.MatchBetFilter.selected.borderColor,
  selectedBackgroundColor = theme.History.historyFilterButton.finished.backgroundColor,
  disabled = false,
  myMatchViewModeIsAvailable,
  className = '',
}: MatchTopMyMatchCardProps) => {
  const isValid = items?.length && !Number.isNaN(parseFloat(odds));

  if (isValid) {
    return (
      <Wrapper className={className}>
        <StyledMyMatchDynamicBackground isActive={myMatchViewModeIsAvailable} />
        <OutcomesWrapper>
          {items.map(({ title, description, outcomeStatus }, idx) => {
            return (
              <HistoryItemOutcomeMyMatchLine
                key={idx}
                outcomeLabel={description}
                outcomeStatus={outcomeStatus}
                betTitle={title}
                showCircle={items.length > 1}
              />
            );
          })}
        </OutcomesWrapper>
        <BottomDiv>
          {!Number.isNaN(parseFloat(odds)) ? (
            <OddDiv>
              <Center>
                <TypoOdd>{__('Odds')}</TypoOdd>
                <TypoNum>{NumberFormatter.formatOdd(parseFloat(odds))}</TypoNum>
              </Center>
            </OddDiv>
          ) : null}
          <Gap />
          <StyledButton
            label={label}
            onClick={onClick}
            isSelected={isSelected}
            color={color}
            selectedColor={selectedColor}
            backgroundColor={backgroundColor}
            borderColor={borderColor}
            selectedBorderColor={selectedBorderColor}
            selectedBackgroundColor={selectedBackgroundColor}
            disabled={disabled}
          />
        </BottomDiv>
      </Wrapper>
    );
  }
  return null;
};

export default React.memo<MatchTopMyMatchCardProps>(MatchTopMyMatchCard);
